import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {Session} from '../../services/session/session.service';
import {DataService} from '../../services/utils/data/data.service';
import {AuthenticationService} from '../../services/auth/auth.service';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES_CLEAN: RouteInfo[] = [];
export const ROUTES: RouteInfo[] = [
    { path: '/dashboard/home', title: 'Panel General',  icon: 'dashboard', class: '' },
    { path: '/administrar/apr', title: 'Administrar APRs',  icon: 'water_damage', class: '' },
    { path: '/configurar', title: 'Configurar',  icon: 'settings', class: '' },
];

export const ROUTES_APR_DIRECTIVO: RouteInfo[] = [
    { path: '/configurar', title: 'Configurar',  icon: 'settings', class: '' },
];

export const ROUTES_APR_ADMINISTRATIVO: RouteInfo[] = [
  { path: '/configurar', title: 'Configurar',  icon: 'settings', class: '' },
];

export const ROUTES_APR_OPERADOR: RouteInfo[] = [
    { path: '/dashboard/home', title: 'Panel General',  icon: 'dashboard', class: '' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor(
    private session: Session,
    private dataService: DataService,
    private router: Router,
    public authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.menuItems = ROUTES_CLEAN.filter(menuItem => menuItem);

    if(this.session.currentUser.nivelPrivilegios == 100){
      this.menuItems = ROUTES.filter(menuItem => menuItem);
    } else if(this.session.currentUser.nivelPrivilegios == 50){
      let idAPRB64 = this.dataService.utf8_to_b64(this.session.currentUser.APR_idAPR);

      var NEW_ROUTES_APR_DIRECTIVO : RouteInfo[] = [
        { path: '/dashboard/apr/' + idAPRB64, title: 'Panel APR',  icon: 'water_damage', class: '' }
      ];

      NEW_ROUTES_APR_DIRECTIVO.push(...ROUTES_APR_DIRECTIVO);
      this.menuItems = NEW_ROUTES_APR_DIRECTIVO.filter(menuItem => menuItem);
    } else if(this.session.currentUser.nivelPrivilegios == 30){
      let idAPRB64 = this.dataService.utf8_to_b64(this.session.currentUser.APR_idAPR);

      var NEW_ROUTES_APR_ADMINISTRATIVO : RouteInfo[] = [
        { path: '/dashboard/apr/' + idAPRB64, title: 'Panel APR',  icon: 'water_damage', class: '' }
      ];

      NEW_ROUTES_APR_ADMINISTRATIVO.push(...ROUTES_APR_ADMINISTRATIVO);
      this.menuItems = NEW_ROUTES_APR_ADMINISTRATIVO.filter(menuItem => menuItem);
    } else {
      this.menuItems = ROUTES_APR_OPERADOR.filter(menuItem => menuItem);
    }

  }

  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };

  salir(){
    this.authService.logout(() => {
      this.router.navigateByUrl("pages/login");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts